import script from "./nav-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-button.vue?vue&type=script&setup=true&lang=ts"

import "./nav-button.vue?vue&type=style&index=0&id=62ac6b5c&lang=scss"

const __exports__ = script;

export default __exports__